import {MultiTargetRelation} from '../MultiTargetRelation';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import type {SketchPointObject} from '../../../../../mesh/sketch/SketchPointObject';

let count = 0;


/**
 * 点-重合关系约束。
 */
export function isPointCoincidentConstraint(value: object): value is PointCoincidentConstraint {
    return Reflect.get(value, "isPointCoincidentConstraint") === true;
}
export class PointCoincidentConstraint extends MultiTargetRelation<SketchPointObject> {
    readonly isPointCoincidentConstraint: boolean = true;
    /**
     * 关系类型。
     */
    public relationType = SketchRelationKind.Coincident;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    public get baseDisplayName(): string {
        return '重合';
    }

}


